import { Matrix4, Quaternion, Vector3, Web3DViewer } from '@technology/web3d';
import { arePointsEqual } from '@trimble/utilities';
import { CapabilityRegistryContainer } from '@trimble/web3d';
import { updateFrustum } from './sync-source-helpers';

const OFFSET_DISTANCE = 10;

/**
 * Shared body for syncing any source into a FreeView pane.
 * Updates the look direction (lookAt quaternion) towards `syncPosition`
 * without moving the FreeView camera in the normal case. If the sync
 * position matches the current camera position, the camera is offset first
 * to avoid a degenerate lookAt calculation.
 */
export function applyToFreeView(
  targetPane: CapabilityRegistryContainer,
  targetViewer: Web3DViewer,
  sourceViewer: Web3DViewer,
  syncPosition: Vector3,
  propagateOrientation: boolean
): void {
  if (arePointsEqual(syncPosition, targetViewer.camera.position)) {
    const offset = new Vector3(0, 0, 1)
      .applyQuaternion(targetViewer.camera.quaternion)
      .multiplyScalar(OFFSET_DISTANCE);
    targetViewer.camera.position = new Vector3(
      targetViewer.camera.position.x + offset.x,
      targetViewer.camera.position.y + offset.y,
      targetViewer.camera.position.z + offset.z
    );
  }

  targetViewer.camera.quaternion = new Quaternion().setFromRotationMatrix(
    new Matrix4().lookAt(
      targetViewer.camera.position,
      syncPosition,
      new Vector3(0, 0, 1)
    )
  );

  updateFrustum(
    targetPane,
    syncPosition,
    propagateOrientation ? sourceViewer.camera.quaternion.toArray() : null,
    propagateOrientation ? sourceViewer.camera.fieldOfView : null
  );
}
